import ShareMsgBase from './A_G.ShareMsgBase';

class MsgFriendshipChestInvite extends ShareMsgBase {
  /**
   * The message that is sent when you sent an invite to a friend to make them join through friendship chest
   * @param {string} user1
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1, onAllImagesReadyCallback = null) {
    super(3, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(41, 126, user1, 0, 141, null);

    this.bg = this._addExtImage(0, 0, 'img/Msg_FriendChest_Invite.png', 0, null, null);

    this.thanksforyourhelp = this.add(new G.Text(334, 61,
      OMT.language.getText('Hey, let\'s play %GameName% together!'), 'msg-black', 0.5, 572, 52, true, 'center'));

    const textData = G.OMTsettings.friendshipChest.layoutData.messageJoined;
    this.prizeText = this.add(new G.Text(336, 207.5, OMT.language.getText('1000 coins!'), {
      style: 'msg-friendChest',
      fontSize: textData.fontSize,
      lineSpacing: textData.lineSpacing,
    }, 0.5, textData.width, textData.height, true, 'center'));

    this._objectLoadComplete();
  }
}

G.MsgFriendshipChestInvite = MsgFriendshipChestInvite;
